export class Mail {

    public metadataId:string;

    public motifRejet:string;
}